// extracted by mini-css-extract-plugin
module.exports = {"werkzaamheden":"Werkzaamheden_werkzaamheden__2893k","heading":"Werkzaamheden_heading__2BL9c"};